// extracted by mini-css-extract-plugin
export default {"searchBox":"IPSearch_searchBox__+VzAu","searchInput":"IPSearch_searchInput__3glzt","searchButton":"IPSearch_searchButton__N6+tN"};